"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useActiveAppSubSections = void 0;
var use_persisted_state_1 = __importDefault(require("use-persisted-state"));
var lodash_1 = require("lodash");
var useActiveAppSubSectionsState = (0, use_persisted_state_1.default)('activeAppSubSections');
var useActiveAppSubSections = function () {
  var _a = __read(useActiveAppSubSectionsState([]), 2),
    activeAppSubSections = _a[0],
    setActiveAppSubSections = _a[1];
  var show = function (id) {
    var newState = [id];
    setActiveAppSubSections((0, lodash_1.filter)(newState));
  };
  var hide = function (id) {
    setActiveAppSubSections((0, lodash_1.filter)((0, lodash_1.without)(activeAppSubSections, id)));
  };
  var isActive = function (id) {
    return (0, lodash_1.includes)(activeAppSubSections, id);
  };
  return {
    show: show,
    hide: hide,
    isActive: isActive,
    toggle: function (id) {
      if (isActive(id)) {
        hide(id);
      } else {
        show(id);
      }
    },
    activeAppSubSections: activeAppSubSections
  };
};
exports.useActiveAppSubSections = useActiveAppSubSections;